import React, {  } from "react";
import { Button, Card, Typography } from "antd";
import { useAuth } from "../../AuthContext/AuthContext";

import { useNavigate } from "react-router-dom";
import { useNotification } from "../../Toast/Notification";

const { Title, Text } = Typography;

const ProfileMobile: React.FC = () => {
 

  const { user, logout } = useAuth();
  const { notify } = useNotification();
  const navigate = useNavigate();

  const userloggut =()=>{
    logout()
    navigate("/")
    notify("User successfully log out", "success")
  }

  return (
    <div className="max-w-4xl mx-auto my-3 p-2">
      <Card
        bordered={false}
        className="bg-white shadow-lg rounded-lg p-6"
        style={{ width: "100%" }}
      >
        <Title level={3} className="text-gray-800 mb-6">Personal Details</Title>

        {user && (
          <ul className="space-y-4">
          {/* User Info Section */}
          <li>
            <Text strong>First Name:</Text>
            <p className="text-gray-600">{user.firstName}</p>
          </li>
          <li>
            <Text strong>Last Name:</Text>
            <p className="text-gray-600">{user.lastName}</p>
          </li>
          <li>
            <Text strong>Email:</Text>
            <p className="text-gray-600">{user.email}</p>
          </li>
          <li>
            <Text strong>Phone Number:</Text>
            <p className="text-gray-600">{user.phoneNumber}</p>
          </li>

          {/* Address Section */}
          <li>
            {/* <Text strong>Address:</Text> */}
            {/* <p className="text-gray-600">{user.address}</p> */}
            <button
                type="button"
                data-modal-target="billingInformationModal"
                data-modal-toggle="billingInformationModal"
                onClick={userloggut}
                className="text-base font-medium text-gray-700 hover:underline dark:text-primary-500">
              Logout
              </button>
            
            <Button
              type="primary"
              className="mt-2"
              onClick={() => alert("Edit Address functionality can be added here.")}
            >
              Edit Address
            </Button>
          </li>
        </ul>
        )}
      </Card>
    </div>
  );
};

export default ProfileMobile;

